/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".float-container[_ngcontent-%COMP%]{padding:20px 20px 30px}.float-popup-footer[_ngcontent-%COMP%]   .button-groups[_ngcontent-%COMP%]{gap:54px}.relocate-options[_ngcontent-%COMP%]{gap:10px;margin-bottom:4px}\n/*# sourceMappingURL=wizard-address-relocation.component.css.map*/"];
export { styles as styles };
